<template>
    <div>
       <video  ref="videoVodTengface" height="100%"  width="100%"
        preload
        :muted="isMuted"
        loop
        x5-video-player-fullscreen="true"
        x5-playsinline
        playsinline
        webkit-playsinline
       :controls="controls" @play="handlePlay" @pause="handlePause" @timeupdate="timeupdate"></video>
    </div>
</template>
<script>
export default {
  name: 'App',
  props: {
    controls: {
      type: Boolean,
      default: false
    },
    src: {
      type: String,
      default: ''
    },
    isMuted: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    duration () {
      return this.$refs.videoVodTengface ? this.$refs.videoVodTengface.duration : 0
    }
  },
  data () {
    return {
      hls: null
    }
  },
  watch: {
    src: {
      handler (val) {
        if (val) {
          this.initHls()
        }
      },
      immediate: true
    }
  },
  methods: {
    handlePlay () {
      console.log('播放')
      this.$emit('play')
    },
    handlePause () {
      this.$emit('pause')
    },
    play () {
      console.log('播放')
      this.$refs.videoVodTengface.play()
    },
    pause () {
      this.$refs.videoVodTengface.pause()
    },
    timeupdate (e) {
      this.$emit('timeupdate', e)
    },
    setCurrentTime (time) {
      if (this.$refs.videoVodTengface) {
        this.$refs.videoVodTengface.currentTime = time
      }
    },
    getCurrentTime () {
      return this.$refs.videoVodTengface ? this.$refs.videoVodTengface.currentTime : 0
    },
    initHls () {
      // eslint-disable-next-line no-undef
      if (Hls.isSupported()) {
        if (!this.hls) {
          // eslint-disable-next-line no-undef
          this.hls = new Hls()
        }
      }
      this.$nextTick(() => {
        this.vodLoad()
      })
    },
    vodLoad () {
      if (this.src) { // 播放hls
        let isM3u8 = this.src.indexOf('.m3u8') > -1
        if (this.hls && isM3u8) {
          this.hls.loadSource(this.src)
          this.hls.attachMedia(this.$refs.videoVodTengface)
        } else {
          this.$refs.videoVodTengface.src = this.src
        }
        console.log('使用hls播放')
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/hlsvideo.vue